export default "__VITE_ASSET__D3ukTX47__"